import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

export const initialState = {
  widgetList: { data: [], loading: false },
  clientUsageStats: { data: [], loading: false },
  clientUsageList: { data: [], loading: false },
  clientCrashStats: { data: [], loading: false },
  clientCrashList: { data: [], loading: false },
  ossDownloadStats: { data: [], loading: false },
  ossDownloadList: { data: [], loading: false },
  loginThreshStats: { data: [], loading: false },
  loginThreshList: { data: [], loading: false },
  dpgIncrementStats: { data: [], loading: false },
  dpgIncrementList: { data: [], loading: false },
  widgetOptions: { data: [], loading: false },
  saving: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
